/* eslint-disable import/prefer-default-export */
import * as NetworksActions from '@src/redux/actions/networks.actions'
import * as NetworkActionTypes from '@src/redux/actionTypes/networks.action.types'
import { getGraph } from '@src/utils/redux.tools'
import type { AutoCompleteQueryResp } from '@src/endpoints/services/graphQueryMgr.service'
import { defaultState } from './default.state'

export const parseGraph = (result_graph?: string) => {
  try {
    return JSON.parse(result_graph)
  } catch (e) {
    return {}
  }
}

export function reducer(
  state = defaultState,
  action: NetworksActions.ActionTypes
) {
  switch (action.type) {
    case NetworkActionTypes.GET_NETWORK_DETAILS: {
      const { auto_complete_resp } = action.payload
      const {
        result_graph = 'null',
        result_table = [],
        options,
        identities,
        objects,
        policies,
        resp_type,
        usage_resp,
        has_next,
        has_prev
      } = auto_complete_resp || ({} as AutoCompleteQueryResp)

      return {
        ...state,
        ...getGraph({ state, graph: parseGraph(result_graph) }),
        result_table,
        options,
        identities,
        objects,
        policies,
        resp_type,
        usage_resp,
        has_next,
        has_prev
      }
    }

    case NetworkActionTypes.GET_NETWORK_DETAILS_TABLE_DATA: {
      const { auto_complete_resp } = action.payload
      const {
        result_table = [],
        options,
        identities,
        objects,
        policies,
        resp_type,
        usage_resp,
        has_next,
        has_prev
      } = auto_complete_resp || ({} as AutoCompleteQueryResp)

      return {
        ...state,
        result_table,
        options,
        identities,
        objects,
        policies,
        resp_type,
        usage_resp,
        has_next,
        has_prev
      }
    }
    default:
      return state
  }
}
